import React from "react";
import { ArrowRight, Phone } from "lucide-react";

const CTA = () => {
  return (
    <section className="hob-cta-section">
      <div className="hob-cta-container">
        <div className="hob-cta-left">
          <h2 className="hob-cta-heading">
            Ready to Build Your Dream Project?
          </h2>
          <p className="hob-cta-description">
            Let us transform your vision into reality with our expert construction services. Get a premium, reliable, and quality-built space today!
          </p>
          <div className="hob-cta-button"
            onClick={() => (window.location.href = "tel:8433630912")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={18} /> Call Now
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;